import Tabs, { TabProp } from "components/tabs"
import styles from './styles.module.scss';
import { RealtorsProfileTab } from "./realtors-profile-tab";
import BaseScreen from "components/base-screen";
import { useMemo } from "react";
import useBoundStore from "store";
import { ClientsProfileTab } from "./clients-profile-tab";

export const Contacts: React.FC = () => {

    const user = useBoundStore((s) => s.user);

    const isClient = useMemo(() => user?.type === 'Client', [user])
    const isRealtor = useMemo(() => user?.type === 'Realtor', [user])

    return (
        <>
            <BaseScreen
                title={isClient ? 'Мои риелторы' : 'Мои контакты'}
            >

                {isClient && <RealtorsProfileTab />}

                {isRealtor && <Tabs
                    contentClassName={styles.profileTabsContent}
                    tabs={[{ title: 'Клиенты', content: <ClientsProfileTab /> },
                        { title: 'Риелторы', content: <RealtorsProfileTab /> },]}
                />}

            </BaseScreen>
        </>
    )
}